var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIntersection2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 196,
    viewBox: "0 0 196 196",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M193.872 2.53121L195.489 4.14787L193.867 65.7903L193.867 130.754L195.488 192.364L193.856 193.996L192.223 195.629L130.613 194.007L65.6495 194.007L4.00687 195.63L2.39018 194.013L0.7735 192.396L2.39567 130.754L2.39568 65.7903L0.773848 4.16091L2.39699 2.53778L4.02012 0.914642L65.6495 2.53647L130.613 2.53647L192.255 0.914306L193.872 2.53121Z",
    fill: "url(#paint0_linear_259_17825)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4929 30.6338L31.635 29.4915L75.1836 30.6375H121.078L164.604 29.492L165.758 30.6453L166.911 31.7985L165.765 75.3245V121.219L166.911 164.768L165.769 165.91L164.627 167.052L121.078 165.906H75.1836L31.6442 167.052L30.4975 165.905L29.3508 164.759L30.4966 121.219V75.3245L29.3506 31.7759L30.4929 30.6338Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_259_17825",
    x1: 195.489,
    y1: 98.2719,
    x2: 0.77351,
    y2: 98.2719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE008F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C20505"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntersection2);
export default __webpack_public_path__ + "static/media/intersection-2.dbf1b965809fa9813e9e5e808140f730.svg";
export { ForwardRef as ReactComponent };